import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../components/grid";
import {
  ESTILO_BOTON_GRILLA_NEXT, ESTILO_BOTON_GRILLA_PREVIOUS,
  ESTILO_BOTON_LISTAR_ATRAS,
  ESTILO_BOTON_LISTAR_NUEVO
} from "../../utils/const-estilos";
import { deshabilitarUsuarioWeb, habilitarUsuarioWeb, obtenerListaUsuariosWeb } from "../../api/usuario/usuario";
import ModalConfirmar from "../../components/modal-confirmar";
import "../../style/style-cargando.css";
import {
  INT_ID_MODULO_USUARIOS,
  INT_ID_SEGUNDO_NIVEL_USUARIOS,
  INT_ID_TERCER_NIVEL_USUARIO_WEB,
  INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
} from "../../utils/const-int";
import { obtenerPermisosPorNivelUsuarioWeb } from "../../api/permisos/permisos";
import { TRUE } from "../../utils/const-bool";
import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const-select-habilitado-deshabilitado";
import Select from "react-select";

const idTipoUsuario = parseInt(localStorage.getItem("idTipoUsuarioDespacho"));
let accesoBotonNuevo = 'none';


export default function ListarUsuarioWeb() {
  const history = useHistory();
  const headers = [
    { key: "acciones", title: "ACCIONES" },
    { key: "id", title: "ID", visible: false, },
    { key: "idtipousuario", title: "IDTIPOUSUARIO", visible: false, },
    { key: "nombre", title: "NOMBRE", filter: true },
    { key: "apellido", title: "APELLIDO", filter: true },
    { key: "usuario", title: "USUARIO", filter: true },
    { key: "fechaproceso", title: "FECHA PROCESO", visible: true, filter: true },
    { key: "idSubTipoUsuarioWeb", title: "idSubTipoUsuarioWeb", visible: false, },
    { key: "subTipoUsuarioWeb", title: "SUB TIPO USUARIO", visible: true, filter: true },
    { key: "idGeocerca", title: "idGeocerca", visible: false, },
  ];
  const [minRows, setMinRows] = useState(0);
  const [maxRows, setMaxRows] = useState(5);
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] =
    useState(false);
  const [usuarioWebSelected, setUsuarioWebSelected] = useState(null);
  const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [estadoHabilitadoSelected, setEstadoHabilitadoSelected] = useState(null);
  useEffect(() => {
    // console.log("entro a ListarUsuarioWeb");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objPermiso = {};
      objPermiso.idMenuPrimerNivel = INT_ID_MODULO_USUARIOS;
      objPermiso.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_USUARIOS;
      objPermiso.idMenuTercerNivel = INT_ID_TERCER_NIVEL_USUARIO_WEB;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(objPermiso);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      let objConfiguracionEnviar = {};
      objConfiguracionEnviar.habilitado = estadoHabilitadoSelected !== null ? estadoHabilitadoSelected.value : null;
      let lista = [];

      if (idTipoUsuario === INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
        accesoBotonNuevo = '';
        setTieneAccesoAlModulo(true);
        lista = await obtenerListaUsuariosWeb(objConfiguracionEnviar);
      }
      if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
        if (permiso.accesoAlModulo === TRUE) {
          setTieneAccesoAlModulo(true);
          lista = await obtenerListaUsuariosWeb(objConfiguracionEnviar);
        }
      }
      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      if (lista.length === 0) {
        setListaUsuarios(lista);
      }
      if (lista.length > 0) {
        const objDeshabilitar = {
          label: "Deshabilitar",
          color: "red",
          onClick: (param) => cambiarEstado(param),
        };
        const objModificar = {
          label: "Modificar",
          color: "green",
          onClick: (param) => editarUsuario(param),
        };
        const objHabilitar = {
          label: "Habilitar",
          color: "blue",
          onClick: (param) => cambiarEstadoHabilitar(param),
        };
        if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
          if (permiso.nuevo === TRUE) {
            accesoBotonNuevo = '';
          }
        }
        for (let i = 0; i < lista.length; i++) {
          const element = lista[i];
          // console.log('element');
          // console.log(element);
          let acciones = [];
          if (idTipoUsuario === INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
            // acciones.push(objDeshabilitar);
            if (element.habilitado === 1) {
              acciones.push(objDeshabilitar);
            }
            if (element.habilitado === 0) {
              acciones.push(objHabilitar);
            }
            acciones.push(objModificar);
          }
          /*if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
            if (permiso.eliminarDeshabilitar === TRUE) {
              acciones.push(objDeshabilitar);
            }
          }*/
          lista[i].acciones = acciones;
        }
        setListaUsuarios(lista);
      }
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const editarUsuario = (data) => {
    try {
      console.log("editarUsuario");
      console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = "MODIFICAR USUARIO WEB";
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      nextPage("usuario-web", obj);
    } catch (err) {
      console.log("editarUsuario err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      console.log("cambiarEstado");
      console.log(data);
      setUsuarioWebSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const nextPage = (page, params) => {
    try {
      // history.push(`${page}`);
      // console.log('params');
      // console.log(params);
      if (params !== undefined && params !== null) {
        if (params.acciones !== undefined) {
          delete params.acciones;
        }
        // console.log('params sin acciones');
        // console.log(params);
        history.push({
          pathname: `${page}`,
          state: params
        });
      } else {
        history.push(`${page}`);
      }
    } catch (err) {
      console.log('nextPage err');
      console.log(err);
    }
  };

  const handleNextPage = () => {
    if (maxRows >= listaUsuarios.length) return;
    setMinRows(maxRows);
    setMaxRows(maxRows + 5);
  };

  const handlePrevPage = () => {
    if (minRows <= 0) return;
    setMaxRows(minRows);
    setMinRows(Math.max(minRows - 5, 0));
  };

  const handleNuevoClick = () => {
    console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.nombre = "";
    data.apellido = "";
    data.usuario = "";
    data.contrasena = "";
    data.nota = "";
    data.idtipousuario = null;
    obj.titulo = "CREAR USUARIO";
    obj.params = data;
    nextPage("usuario-web", obj);
  }

  const handleAtrasClick = () => {
    history.goBack();
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (usuarioWebSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = usuarioWebSelected.id;
    if (usuarioWebSelected.id > 0) {
      // console.log('crear correo');
      let deshabilitado = await deshabilitarUsuarioWeb(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert('Se deshabilito correctamente');
        reset();
      }
      if (deshabilitado === false) {
        alert('No se pudo deshabilitar');
      }
    }
  }

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  }

  const handleEstadoChecklist = (event) => {
    setEstadoHabilitadoSelected(event);
  }

  const handleBuscarClick = () => {
    reset();
  }

  const cambiarEstadoHabilitar = async (data) => {
    try {
      setUsuarioWebSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleCancelModalHabilitar = () => {
    setModalConfirmarHabilitarVisible(false);
  };

  const handleConfirmModalHabilitar = async () => {
    try {
      // console.log("Modal confirmado!");
      // console.log('tipoCarroceriaSelected');
      // console.log(tipoCarroceriaSelected);
      setModalConfirmarHabilitarVisible(false);
      let obj = {};
      obj.id = usuarioWebSelected.id;
      const habilitado = await habilitarUsuarioWeb(obj);
      // console.log('habilitado');
      // console.log(habilitado);
      if (habilitado === true) {
        alert("Se habilito correctamente");
        reset();
      }
      if (habilitado === false) {
        alert("No se pudo habilitar sub tipo carroceria");
      }
    } catch (err) {
      console.log("handleConfirmModalHabilitar err");
      console.log(err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div className="loader"></div>
            <div
              style={{ marginTop: 10, }}
            >
              <p>Cargando...</p>
            </div>
          </div>
        );
      }
      if (tieneAccesoAlModulo === false) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div
              style={{ marginTop: 10, }}
            >
              <p>Sin Acceso Al Modulo...</p>
            </div>
          </div>
        );
      }
      return (
        <div>
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              paddingLeft: 10,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              LISTA USUARIO WEB
            </label>
            <button
              type="button"
              className={ESTILO_BOTON_LISTAR_ATRAS}
              onClick={handleAtrasClick}
            >
              ATRAS
            </button>
          </div>
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              paddingLeft: 10,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div className="flex align-center" >
              <Select
                options={SELECT_HABILITADO_DESHABILITADO}
                isSearchable={true}
                isClearable={true}
                value={estadoHabilitadoSelected}
                onChange={(event) => handleEstadoChecklist(event)}
                placeholder="Seleccione Estado"
              />
              <div
                style={{ width: 10 }}
              ></div>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={handleBuscarClick}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                BUSCAR
              </button>
            </div>
            <button
              type="button"
              className={ESTILO_BOTON_LISTAR_NUEVO}
              onClick={handleNuevoClick}
              style={{
                display: accesoBotonNuevo,
              }}
            >
              NUEVO
            </button>
          </div>
          <Grid rows={listaUsuarios} headers={headers} />
          <div>
            <button className={ESTILO_BOTON_GRILLA_PREVIOUS} onClick={handlePrevPage}>Previous</button>
            <button className={ESTILO_BOTON_GRILLA_NEXT} onClick={handleNextPage}>Next</button>
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message="¿Estás de deshabilitar usuario?"
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={handleCancelModalHabilitar}
            onConfirm={handleConfirmModalHabilitar}
            message="¿Esta seguro de habilitar este usuario?"
          />
        </div>
      );
    } catch (err) {
      console.log('index render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
